import {defineCssVars} from '@chakra-ui/styled-system';

export const vars = defineCssVars(`alert`, [
  `in`,
  `font-weight`,
  `font-size`,
  `gap`,
  `padding-left`,
  `padding-right`,
  `padding-top`,
  `padding-bottom`,
  `background`,
  `color`,
  `icon-color`,
]);
